import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
	selector: 'conversation-close-warning',
	templateUrl: './conversation-close-warning.component.html',
	styleUrls: ['./conversation-close-warning.component.scss'],
	standalone: false
})
export class ConversationCloseWarningComponent implements OnInit {
	public accountIdToRemove: number;

	constructor(
		public dialogRef: MatDialogRef<ConversationCloseWarningComponent>,
		@Inject(MAT_DIALOG_DATA) private data: { data: { accountIdToRemove: number } }
	) {
		this.accountIdToRemove = this.data?.data?.accountIdToRemove;
	}

	ngOnInit() {}

	public reallyClose() {
		this.dialogRef.close(true);
	}
}
